import { useParams, useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SeagForm from '@/features/partners/SeagForm.tsx';

const PartnerFormPage = () => {
  const { partnerId } = useParams<{ partnerId: string }>();
  const navigate = useNavigate();

  if (partnerId !== 'seag') {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h5">Formulario no encontrado</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          p: 2,
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <IconButton onClick={() => navigate('/partners')}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6">SEAG - Seguros de Alquiler</Typography>
      </Box>
      <SeagForm />
    </Box>
  );
};

export default PartnerFormPage;
